import * as React from "react";
import { react2Angular } from "~/Core/React2Angular";

export const DropDownDisplay = ({ listOptions, entityId }: { listOptions: string; entityId: string }) => {
    if (!entityId) {
        return null;
    }

    let value = entityId;
    const splitOptions = listOptions.split("||");
    for (let x = 0; x < splitOptions.length; x++) {
        const parts = splitOptions[x].split("|");
        if (parts.length > 1 && entityId === parts[1]) {
            value = parts[0];
        }
    }

    return <span>{value}</span>;
};

angular
    .module("insite-admin")
    .component("dropDownDisplay", react2Angular(DropDownDisplay, ["listOptions", "entityId"]));
